"use client";
import React from "react";
import { ReactCookieFirst } from '@cookiefirst/cookiefirst-react'

import CookieFirstHandler from "./CookieFirstHandler";
import useSmoothScroll from "../hooks/useSmoothScroll";
const PageHandler = ({ location }) => {
	useSmoothScroll();
	return (
		<>
			<ReactCookieFirst url={process.env.GATSBY_COOKIE_FIRST_CONSENT_URL}>
				<CookieFirstHandler location={location} />
			</ReactCookieFirst>
		</>
	);
};

export default PageHandler;
